import { NormalSmoothingFeature } from '@kb3d/models/classes/features/normal-smoothing-feature';
import { Token } from '@kb3d/models/classes/token';
import { ITrackedClass } from '@kb3d/models/interfaces/tracked-class';
import { SubmeshVertexData } from '@kb3d/view/helpers/geometry-helper';
import { FeatureRenderer } from './feature';
import { NormalSmoothingGeometryProcessor } from './geometry-processor/normal-smoothing-geometry';

export class NormalSmoothingRenderer extends FeatureRenderer<NormalSmoothingFeature> {
    modelToken = Token.NormalSmoothingFeature;
    processor = new NormalSmoothingGeometryProcessor(this.scene);

    update3dInternal(feature: NormalSmoothingFeature) {}

    postUpdateGeometry(feature: ITrackedClass<NormalSmoothingFeature>, _vertexData: SubmeshVertexData): void {
        const totalVertices = feature.vertexGroups.reduce((acc, vertexGroup) => {
            acc += vertexGroup.startIndex - vertexGroup.endIndex;
            return acc;
        }, 0);
        this.viewer.updateFeatureWarnings(feature, totalVertices, false);
    }

    public delete3d(node: ITrackedClass<NormalSmoothingFeature>, preserveCache?: boolean | undefined): void {
        super.delete3d(node);
    }
}
